import React from 'react'
/* eslint-disable react/forbid-prop-types */
import { any } from 'prop-types'
import PermissionRouteWithFallback from './PermissionRouteWithFallback'

export default function FamousRelativesPermissionRouteWithFallback({
  component: Component,
  path,
  exact,
  fallback: Fallback,
  children,
  requirePersonalData,
}) {
  return (
    <PermissionRouteWithFallback
      component={Component}
      path={path}
      exact={exact}
      fallback={Fallback}
      requirePersonalData={requirePersonalData}
      permissionName="DiscoveryFamousManageContentPermission"
      permissionContext="DiscoveryManageContentContext"
    >
      {children}
    </PermissionRouteWithFallback>
  )
}

FamousRelativesPermissionRouteWithFallback.propTypes = {
  children: any,
  component: any,
  fallback: any.isRequired,
  path: any,
  exact: any,
  requirePersonalData: any,
}
